import { Box, Breadcrumbs, Button, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import {
  BooleanInput,
  Edit,
  Form,
  PasswordInput,
  SaveButton,
  TextInput,
  email,
  minLength,
  required,
  useTranslate,
} from 'react-admin';
import { Link, useParams } from 'react-router-dom';
import AvatarInput from '../../components/AvatarInput';
import { validatePasswords } from './MembersCreate';

export const MembersEdit = () => {
  const translate = useTranslate();
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const { id } = useParams();
  return (
    <Box pt={2}>
      <Breadcrumbs aria-label="breadcrumb">
        <Typography
          color="inherit"
          sx={{ fontSize: '14px', fontWeight: '400', lineHeight: '19px' }}
          component={Link}
          to="/teams"
        >
          Equipo
        </Typography>
        <Typography
          color="textPrimary"
          sx={{ fontSize: '14px', fontWeight: '600', lineHeight: '19px' }}
        >
          Editar Miembro
        </Typography>
      </Breadcrumbs>
      <Box maxWidth={{ xs: '100%', sm: 850 }} mt={{ xs: 2 }} mx="auto">
        <Typography color="textPrimary" variant="h5" sx={{ mb: 2 }}>
          Editar Miembro
        </Typography>
        <Edit
          resource="members"
          id={id}
          redirect="/teams"
          title={' '}
          sx={{ '& .RaEdit-card': { p: 2 } }}
        >
          <Form validate={validatePasswords}>
            <Box width={{ xs: '100%!important', md: '60%!important' }}>
              <Box display={{ xs: 'block', sm: 'flex' }}>
                <Box flex={1} style={{ alignSelf: 'center' }}>
                  <AvatarInput resource="members" source="avatar" fullWidth />
                </Box>
              </Box>
              <Box display={{ xs: 'block', sm: 'flex' }}>
                <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
                  <TextInput
                    source="first_name"
                    label="Nombre"
                    validate={requiredValidate}
                    fullWidth
                  />
                </Box>
                <Box flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                  <TextInput
                    source="last_name"
                    label="Apellido"
                    validate={requiredValidate}
                    fullWidth
                  />
                </Box>
              </Box>
              <Box flex={1}>
                <TextInput
                  type="email"
                  source="email"
                  resource="members"
                  validate={[email(), required()]}
                  sx={{ width: '100%', maxWidth: '300px' }}
                />
              </Box>
              {/* <Box mt="0.5em" />
              <Box flex={1}>
                 <ReferenceInput source="roles" reference="roles">
                  <SelectInput
                    label="Rol"
                    optionText="name"
                    validate={requiredValidate}
                  />
                </ReferenceInput>
              </Box>
              <Box mt="0.5em" /> */}

              <Box flex={1}>
                <TextInput
                  source="external_id"
                  resource="members"
                  label="external_id"
                  fullWidth
                />
              </Box>

              <Box mt="0.5em">
                <Typography variant="h6">Rol</Typography>
                <BooleanInput
                  label={translate('resources.members.create.manager')}
                  source="rolegerente"
                  defaultValue={false}
                  format={v => !!v}
                  parse={v => !!v}
                />
              </Box>

              <Box mt="1em" />
              <Box display="flex" alignItems="center" mb={2} gap={2}>
                <Typography variant="h6">
                  {translate('resources.profile.password')}
                </Typography>
                <Button
                  variant="outlined"
                  sx={{ padding: '4px 16px !important' }}
                  onClick={() => setShowPasswordFields(prevState => !prevState)}
                >
                  {translate('resources.profile.change')}
                </Button>
              </Box>

              {showPasswordFields ? (
                <Box display={{ xs: 'block', sm: 'flex' }}>
                  <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
                    <PasswordInput
                      label="Nueva contraseña"
                      source="password"
                      resource="members"
                      fullWidth
                      validate={minLength(6)}
                    />
                  </Box>
                  <Box flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                    <PasswordInput
                      label="Confirmar contraseña"
                      source="password_confirmation"
                      resource="members"
                      validate={minLength(6)}
                      fullWidth
                    />
                  </Box>
                </Box>
              ) : null}
            </Box>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="flex-end"
            >
              <SaveButton
                sx={{
                  backgroundColor: '#3F49DB',
                  borderRadius: '500px !important',
                  textTransform: 'none !important',
                  fontSize: '14px !important',
                  lineHeight: '19px !important',
                  fontWeight: '600 !important',
                  letterSpacing: '0.5px !important',
                  padding: '8px 32px!important',
                  boxShadow: 'none !important',
                  svg: {
                    display: 'none',
                  },
                }}
              />
            </Grid>
          </Form>
        </Edit>
      </Box>
    </Box>
  );
};

const requiredValidate = [required()];
